import { validateBankDetailsCommonFields } from '@/core/validation/common/bank-details';
import { BankDetailFieldErrors } from '@/core/validation/field-errors';
import { BANK_DETAILS } from '@/core/field-names';
import bsb from '@/core/svc-client/bsb';

export async function validateBankDetails(field) {
  switch (field.name) {
    case BANK_DETAILS.BSB: {
      if (!field.value) {
        return BankDetailFieldErrors.InvalidBSB;
      }

      const val = field.value.replace(/\s/g, '');
      if (val.length < 6) {
        return BankDetailFieldErrors.InvalidBSB;
      }

      try {
        await bsb.get(val.replace(/(\d{3})(?=\d)/g, '$1-'));
      } catch (e) {
        return BankDetailFieldErrors.InvalidBSB;
      }
      break;
    }

    default: {
      return validateBankDetailsCommonFields(field);
    }
  }
}
